//
//
//
//
//
//
//
//
//
//

export default {
	name: 'InsureView',
};
